module.exports = __webpack_public_path__ + "img/LIP.739de469.jpg";